import {VIEW_USER_SUCCESS, VIEW_USER_REQUEST, STREAM_STATUS_STARTED} from '../constants/streaming';

const metricsMiddleware = (store) => (next) => (action) => {
    let dl = window.dataLayer || [];

    /*
    let streamLabel = "";
    if (action.type == VIEW_USER_REQUEST || action.type == VIEW_USER_SUCCESS) {

        let {currentUser} = store.getState();
        try {
            streamLabel = currentUser.nick + ":" + action.ufrag.split('_')[0];
        } catch(e) {
            console.log(e.message);
        }
        
    }
    
    if (action.type == VIEW_USER_REQUEST) {
                    
        dataLayer.push({
            'event': 'streamWatchRequest',
            'eventCategory': 'stream',
            'eventAction': 'streamWatchRequest',
            'eventLabel': streamLabel
        });        
    }

    if (action.type == VIEW_USER_SUCCESS) {
    
        dataLayer.push({
            'event': 'streamWatchSuccess',
            'eventCategory': 'stream',
            'eventAction': 'streamWatchSuccess',
            'eventLabel': streamLabel
            //'eventValue': 0 //todo: add load time
        });        
    }
*/
/*
    if (action.type === VIEW_USER_SUCCESS) {

        let user = store.getState().users.get({ufrag: action.ufrag});

        if( user && !user.paused ) {
            if ( (user.isXXL() && user.gender==2) || user.gift_rank > 0 || user.token_rank > 0 ) {

                window.setTimeout(function(){ // It takes time to get the stream ready to use

                    let videostream_track = action.stream.getVideoTracks()[0];

                    if(videostream_track) {
                        let videostream_settings = videostream_track.getSettings();

                        if(typeof videostream_settings.width !== 'undefined' && videostream_settings.frameRate > 0) {

                            let ga_label = videostream_settings.width + "x" + videostream_settings.height;

                            dataLayer.push({
                                'event': 'streamOpened',
                                'eventCategory': 'stream',
                                'eventAction': 'streamOpened',
                                'eventLabel': ga_label
                            });
                            // console.log("stream(" + user.nick + ")", videostream_settings.width + "x" + videostream_settings.height + "x" + Math.round(videostream_settings.frameRate));

                        }

                    }
                }, 5000);

            } else {
                window.setTimeout(function(){ // It takes time to get the stream ready to use
                    let videostream_track = action.stream.getVideoTracks()[0];
                    if(videostream_track) {
                        let videostream_settings = videostream_track.getSettings();
                        if(typeof videostream_settings.width !== 'undefined') {
                            // console.log("stream(" + user.nick + ")", videostream_settings.width + "x" + videostream_settings.height + "x" + Math.round(videostream_settings.frameRate));
                        }
                    }
                }, 5000);
            }
        }

    }
*/

    if (action.type === STREAM_STATUS_STARTED) {
        let videostream,
            videostream_settings,
            videostream_capabilities,
            ga_label;

        try {
            videostream = action.stream.getVideoTracks()[0];
            if(videostream && (videostream_settings = videostream.getSettings())) {
                ga_label = videostream_settings.width + "x" + videostream_settings.height + "x" + Math.round(videostream_settings.frameRate);
                dl.push({
                    'event': 'streamCaptured',
                    'eventCategory': 'stream',
                    'eventAction': 'streamCaptured',
                    'eventLabel': ga_label
                });
            }
        } catch(e) {
            dl.push({
                'event': 'streamCaptured',
                'eventCategory': 'stream',
                'eventAction': 'streamCaptured',
                'eventLabel': "exception:" + e.message
            });
        }

/*
        try {
            videostream = action.stream.getVideoTracks()[0];
            if(videostream && (videostream_capabilities = videostream.getCapabilities())) {
                ga_label = videostream_capabilities.width.max + "x" + videostream_capabilities.height.max;
                dataLayer.push({
                    'event': 'streamMaxResolution',
                    'eventCategory': 'stream',
                    'eventAction': 'streamMaxResolution',
                    'eventLabel': ga_label
                });
            }
        } catch(e) {
            dataLayer.push({
                'event': 'streamMaxResolution',
                'eventCategory': 'stream',
                'eventAction': 'streamMaxResolution',
                'eventLabel': "exception:" + e.message
            });
        }

 */
    }

    next(action);
};

export default metricsMiddleware;


// WEBPACK FOOTER //
// ./src/middleware/metrics.js